import { render } from "./Chapter.vue?vue&type=template&id=920228fc"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"
script.render = render

export default script